import { Injectable, Signal } from '@angular/core';
import { User } from '@web-portal/domains/shared/domain-models';

export interface UserSignalr {
  init(): void;
}

@Injectable()
export abstract class UserStrategy {
  abstract user: Signal<User | null>;
  abstract initials: Signal<string>;
  abstract userSignalrService: UserSignalr;
}
